import React, { PureComponent } from 'react'
import { number, bool, arrayOf, shape, oneOf } from 'prop-types'
import { line as d3Line, scaleLinear, curveLinear, curveBasis, select } from 'd3'
import { minBy, maxBy } from 'lodash'

export class SvgPathLine extends PureComponent {
    static propTypes = {
        data: arrayOf(shape({
            x: number.isRequired,
            y: number.isRequired,
        })).isRequired,
        inputRange: shape({
            x: arrayOf(number),
            y: arrayOf(number)
        }),
        outputViewBox: shape({
            x: number.isRequired,
            y: number.isRequired,
            width: number.isRequired,
            height: number.isRequired
        }).isRequired,
        interpolated: bool,
        animationDuration: number,
        startAnimation: oneOf(['none', 'fromBottom'/* , 'fromLeft', 'fadeIn' */]) // TODO: implement 'fadeIn' and 'fromLeft' with dashStrokeArray
    }

    static defaultProps = {
        inputRange: {},
        interpolated: false,
        animationDuration: 1000,
        startAnimation: 'none'
    }

    componentWillMount() {
        const { data, startAnimation } = this.props
        this.line = undefined
        this.refreshScales(this.props)
        if (startAnimation === 'fromBottom') {
            this.refreshLine({ ...this.props, data: data.map(({ x, y }) => ({ x, y: 0 })) })
        } else if (!startAnimation || startAnimation === 'none') {
            this.refreshLine(this.props)
        }
    }
    componentDidMount() {
        const { startAnimation } = this.props
        if (startAnimation === 'fromBottom') {
            this.refreshLine(this.props)
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.inputRange !== this.props.inputRange || nextProps.outputViewBox !== this.props.outputViewBox) {
            this.refreshScales(nextProps)
        }
        if (nextProps.data !== this.props.data || nextProps.interpolated !== this.props.interpolated) {
            this.refreshLine(nextProps)
        }
    }

    setPathRef = ref => {
        this.pathRef = ref
    }

    refreshScales = props => {
        const { data, inputRange, outputViewBox } = props
        let [xMin, xMax] = (inputRange || {}).x || [undefined, undefined]
        let [yMin, yMax] = (inputRange || {}).y || [undefined, undefined]
        if (typeof xMin !== 'number') xMin = minBy(data, d => d.x).x
        if (typeof xMax !== 'number') xMax = maxBy(data, d => d.x).x
        if (typeof yMin !== 'number') yMin = minBy(data, d => d.y).y
        if (typeof yMax !== 'number') yMax = maxBy(data, d => d.y).y
        this.xScale = scaleLinear().domain([xMin, xMax]).range([outputViewBox.x, outputViewBox.x + outputViewBox.width])
        this.yScale = scaleLinear().domain([yMin, yMax]).range([outputViewBox.y + outputViewBox.height, outputViewBox.y])
    }
    refreshLine = props => {
        const { data, interpolated, animationDuration } = props
        if ((data || []).lenght === 0) {
            this.line = null
        } else if (this.line) {
            select(this.pathRef).transition().duration(animationDuration).attr('d', this.calculateLine(data, interpolated))
        } else {
            this.line = this.calculateLine(data, interpolated)
        }
    }
    calculateLine = (data, interpolated) => {
        if (this.xScale && this.yScale) {
            return d3Line().x(d => this.xScale(d.x)).y(d => this.yScale(d.y)).curve(interpolated ? curveBasis : curveLinear)(data)
        }
        return null
    }

    render() {
        const { data, inputRange, outputViewBox, interpolated, animationDuration, startAnimation, className, ...otherProps } = this.props
        return (
            <path ref={this.setPathRef} className={['SvgLine', className]} d={this.line} {...otherProps} />
        )
    }
}



// WEBPACK FOOTER //
// src/components/Svg/SvgPathLine.js